import axios from 'axios'


export default axios.create({
    baseURL: `${process.env.REACT_APP_PROVIDER2}`,
    headers: {
        'platform': "qr",
        countryId: localStorage.getItem("countryId"),
        'Content-type': 'application/json'
    }
})